let mixin = {
    data() {
        return {
            limit: 10,
            starts: 0,
            pageNo: 0,
            token: null,
            top: 0,
            token: null,
            month: null,
            res: null,
            unitList: [],
            jx: 0, //1是江西， 0非江西
            // xuZhou: 0, //1是衢州， 0非衢州
            quZhou: 0, //1是衢州， 0非衢州
        }
    },

    created() {
        // alert(JSON.stringify(this.$route.query))
        // query
        if (this.$route && this.$route.query.jx) {
            this.jx = this.$route.query.jx;
        }
        if (this.$route && this.$route.query.quZhou) {
            if (Array.isArray(this.$route.query.quZhou)) {
                this.quZhou = this.$route.query.quZhou[0];
            } else {
                this.quZhou = this.$route.query.quZhou
            }
        }
        if (this.$route && this.$route.query.xuZhou) {
            if (Array.isArray(this.$route.query.xuZhou)) {
                this.quZhou = this.$route.query.xuZhou[0];
            } else {
                this.quZhou = this.$route.query.xuZhou
            }
        }
        this.token = this.$route ? this.$route.query.token : '' || '';
        // kuk03xipo7ew23220300s9nehemaegnx
        if (this.token) {
            localStorage.setItem('token', this.token);
        }
        var date = new Date();
        this.month = this.$func.getMonth();
    },
    // mounted(){
    //     window.getIosData = this.getIosData;
    // },
    methods: {
        setSign(param) {
            var str = '',
                // secret = 'YvhyhbFsVibte5znb3L3xSpqj04is4K5', //正式
                secret = 'AGPWEvO7nTvKa39zA0lyNnn5MeeaNM2M',
                parm = JSON.parse(JSON.stringify(param));
            var newParam = this.objKeySort(parm);
            var key = Object.keys(newParam).slice(-1)[0];
            for (var item in newParam) {
                if (Array.isArray(newParam[item])) {
                    continue
                }
                if (newParam[item] === "") {
                    continue
                }
                str += item + '=' + newParam[item] + '&';
            }
            str += 'secret=' + secret;
            return (this.$md5(str)).toUpperCase()
        },
        objKeySort(obj) { //排序的函数
            var newkey = Object.keys(obj).sort();
            var newObj = {};
            for (var i = 0; i < newkey.length; i++) {
                newObj[newkey[i]] = obj[newkey[i]];
            }
            return newObj;
        },
    },
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixins/index.js